export default class MeigarachartService {
  getAll(meigaraMenuId, period, mcd) {
    return fetch("https://api.tradersr.com/api/meigarachart?menuid=" + meigaraMenuId + "&period=" + period + "&mcd=" + mcd)
      .then(res => res.json());
  }
}